export const CREATE_PROFILE_SUCCESS = "profile/create_profile_success";
export const CREATE_PROFILE_FAIL = "profile/create_profile_fail";

export const UPDATE_PROFILE_SUCCESS = "profile/update_profile_success";
export const UPDATE_PROFILE_FAIL = "profile/update_profile_fail";

export const GET_PROFILE_SUCCESS = "profile/get_profile_success";
export const GET_PROFILE_FAIL = "profile/get_profile_fail";

export const GET_PROFILE_BY_SEARCH_SUCCESS = "profile/get_profile_by_search_success";
export const GET_PROFILE_BY_SEARCH_FAIL = "profile/get_profile_by_search_fail";

export const GET_PROFILE_BY_USERID_SUCCESS = "profile/get_profile_by_userid_success";
export const GET_PROFILE_BY_USERID_FAIL = "profile/get_profile_by_userid_fail";

export const GET_PROFILE_BY_PROFILEID_SUCCESS = "profile/get_profile_by_profileid_success";
export const GET_PROFILE_BY_PROFILEID_FAIL = "profile/get_profile_by_profileid_fail";

export const DELETE_PROFILE_SUCCESS = "profile/delete_profile_success";
export const DELETE_PROFILE_FAIL = "profile/delete_profile_fail";

export const  SEND_REQUEST_SUCCESS = "profile/send_request_success";
export const  SEND_REQUEST_FAIL = "profile/send_request_fail";

export const ACCEPT_REQUEST_SUCCESS = "profile/send_request_success";
export const ACCEPT_REQUEST_FAIL = "profile/send_request_fail";

export const REJECT_REQUEST_SUCCESS = "profile/reject_request_success";
export const REJECT_REQUEST_FAIL = "profile/reject_request_fail";

export const VIEW_PROFILE_SUCCESS = "profile/view_profile_success"; 
export const VIEW_PROFILE_FAIL = "profile/view_profile_fail"; 